import React from "react";
import "./UserStack.scss"
import user from "../../assets/user.svg"
const UserStack = ({ userCount }) => {
    return (
        <div className="UserStack">
            <div className="UserStack-contianer">
                <div className="UserStack-user-wrapper-1">
                    <img alt="" src={user} className="UserStack-user-wrapper-1-ico" />
                </div>
                <div className="UserStack-user-wrapper-2">
                    <img alt="" src={user} className="UserStack-user-wrapper-2-ico" />
                </div>    <div className="UserStack-user-wrapper-3">
                    <img alt="" src={user} className="UserStack-user-wrapper-3-ico" />
                </div>
            </div>
            <div className="UserStack-text">
                <b>{userCount}</b>
                businesses trust WitEarn
            </div>
        </div>
    )
}
export default UserStack